import { Grid} from "@mui/material"
import Input from "../../../components/Input"
const Contact = ({fieldValues, handleOnChange}) => {
    const fields = [
        {name:'f_name', label:'First Name', type: 'input'},
        {name:'l_name', label:'Last Name', type: 'input'}, 
        {name:'email', label:'Email', type: 'input'},
        {name:'phone', label:'Phone Number', type: 'input'},
        {name:'city', label:'City', type: 'input'},
        {name:'state', label:'State', type: 'input'},
        {name:'designation', label:'Designation', type: 'input'},
    ]
    return <Grid container>
        {fields.map((field, index)=>{
            return <Grid item xs={6} p={3}>
                <Input name={field.name} label={field.label} key={index} value={fieldValues[field.name]} handleOnChange={handleOnChange}/>
             </Grid>
        })}
    </Grid>
}

export default Contact